export default (idSituation: string): string => {
  switch (parseInt(idSituation, 10)) {
    case -2:
      return '#d3d3d3';
    case -1:
      return '#FFD700';
    case 0:
      return '#71b6f1';
    case 1:
      return '#FFFF30';
    case 2:
      return '#f1f1a6';
    case 3:
      return '#F4C196';
    case 4:
      return '#e0e8de';
    case 5:
      return '#cedaca';
    case 6:
      return '#BEF6D4';
    case 7:
      return '#BEE2D4';
    case 9:
      return '#FF9C9F';
    case 10:
      return '#d8d1d1';
    default:
      return '';
  }
};
